import { styled } from '@mui/material/styles'
import { Box, TextField } from '@mui/material'

export const StyledTextField = styled(TextField)<{ hasError?: boolean }>(({ hasError }) => ({
  width: '100%',
  background: 'white !important',
  '& .MuiOutlinedInput-root': {
    height: 40,
    borderRadius: '8px',
    backgroundColor: 'white',
    '& fieldset': {
      borderColor: hasError ? '#f44336' : '#EFEFEF'
    },
    '&:hover fieldset': {
      borderColor: hasError ? '#f44336' : '#EFEFEF'
    },
    '&.Mui-focused fieldset': {
      borderColor: hasError ? '#f44336' : '#2570EB'
    }
  },
  '& .MuiOutlinedInput-input': {
    fontSize: '12px'
  },
  '& .MuiInputBase-input::placeholder': {
    fontSize: '12px',
    color: '#989898'
  },
  '& .MuiFormHelperText-root': {
    fontSize: '10px',
    marginLeft: 0,
    marginTop: '4px'
  }
}))

export const StyledTextArea = styled(TextField)<{ hasError?: boolean }>(({ hasError }) => ({
  width: '100%',
  background: 'white !important',
  '& .MuiOutlinedInput-root': {
    minHeight: 60,
    maxHeight: 100,
    borderRadius: '8px',
    backgroundColor: 'white',
    alignItems: 'flex-start',
    '& fieldset': {
      borderColor: hasError ? '#f44336' : '#EFEFEF'
    },
    '&:hover fieldset': {
      borderColor: hasError ? '#f44336' : '#EFEFEF'
    },
    '&.Mui-focused fieldset': {
      borderColor: hasError ? '#f44336' : '#2570EB'
    }
  },
  '& .MuiOutlinedInput-input': {
    fontSize: '12px',
    minHeight: '60px !important',
    overflow: 'auto',
    resize: 'none'
  },
  '& .MuiInputBase-input::placeholder': {
    fontSize: '12px',
    color: '#989898'
  }
}))

export const ButtonContainer = styled(Box)({
  backgroundColor: 'white',
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '8px',
  padding: '16px 24px',
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: '24px',
    right: '24px',
    height: '1px',
    backgroundColor: '#EFEFEF'
  }
})

export const CancelButton = styled(Box)({
  padding: '12px 24px',
  height: 40,
  display: 'flex',
  alignItems: 'center',
  borderRadius: '8px',
  border: '1px solid #EFEFEF',
  backgroundColor: 'white',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: '#f5f5f5'
  }
})

export const SubmitButton = styled('button')<{ loading?: boolean }>(({ loading }) => ({
  padding: '12px 24px',
  height: 40,
  display: 'flex',
  alignItems: 'center',
  borderRadius: '8px',
  border: 'none',
  backgroundColor: '#2570EB',
  color: 'white',
  cursor: loading ? 'not-allowed' : 'pointer',
  '&:hover': {
    backgroundColor: loading ? '#2570EB' : '#1d5acc'
  },
  '&:disabled': {
    opacity: 0.6,
    cursor: 'not-allowed'
  }
}))